import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";

import Imagen3 from "../../../images/modulo13/laparada.png";
import Imagen4 from "../../../images/modulo13/brena.png";

const Actividad1 = () => {
  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[1];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[2].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[2].path}`,
    titlePrev: `${modulo13.content[2].name}: ${modulo13.content[2].activities[0].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[0].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-4">
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-3 p-md-3">
          <h2 className="mb-4">La vida en la ciudad </h2>

            <p>
              Como ya sabemos, la mayor parte de la población peruana vive hoy
              en ciudades. Estas acogen a una gran diversidad de personas con
              sus costumbres, tradiciones, lenguas y actividades económicas.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen3} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen4} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              La <strong>concentración</strong> de una gran cantidad de personas en un mismo
              lugar genera una serie de necesidades. No solo se requieren muchos
              <strong>recursos</strong> para que todos puedan alimentarse y vestirse. También es
              necesario proveer a las personas de <strong>servicios</strong> de agua, desagüe,
              electricidad y transporte.
            </p>
            <p>
              Para atender las necesidades de todos los habitantes de las
              ciudades, se requiere grandes cantidades de recursos naturales y
              una importante transformación del territorio.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean en silencio el texto titulado: La
            vida en la ciudad. Formule esta pregunta:
            <ul>
              <li>
                <i>
                  “¿Qué sucede en una ciudad cuando tiene muchos pobladores?
                  (Posible respuesta: La concentración de mucha gente en un solo
                  lugar requiere de una gran inversión de recursos y de la
                  provisión de servicios que puedan cubrir las necesidades de la
                  población. Asimismo, el crecimiento de las ciudades trae como
                  consecuencia que se transforme el territorio. Como veremos más
                  adelante, muchas veces ello ocurre con impactos negativos para
                  el medio ambiente.”
                </i>
              </li>
            </ul>
          </li>

          <li>Lea nuevamente en voz alta el texto.</li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
